<template>
    <div class="modal__container">
        <div class="modal__alert__container" v-show="showAlert">
            <div class="container">
                <div class="modal__alert alert alert-success" role="alert">
                    Het opslaan van uw inzending is <strong>gelukt</strong>. U kunt nu <a :href="projectUrl">hier</a> uw inzending bekijken.
                </div>
            </div>
        </div>

        <transition name="modal" v-if="showModal">
            <div class="modal modal-mask" style="display: block">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">
                                Ontwerp opslaan
                            </h4>
                        </div>

                        <div class="modal-body">

                            <form class="form-horizontal">
                                <div
                                    class="form__errors col-md-offset-0 col-md-12 bg-warning"
                                    v-html="errorMessages"
                                    v-show="errorMessages"
                                >
                                </div>
                                <div class="form-group">
                                    <label for="form__field__full-name" class="col-sm-3 control-label">Naam *</label>
                                    <div class="col-sm-9">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="form__field__full-name"
                                            placeholder="Naam"
                                            v-model="form.full_name"
                                        >
                                        <p class="help-block">Uw naam wordt getoond bij het ontwerp op de website.</p>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="form__field__email" class="col-sm-3 control-label">
                                        Email *
                                    </label>
                                    <div class="col-sm-9">
                                        <input
                                            type="email"
                                            class="form-control"
                                            id="form__field__email"
                                            placeholder="Email"
                                            v-model="form.email"
                                        >
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="form__field__address" class="col-sm-3 control-label">
                                        Adres
                                    </label>
                                    <div class="col-sm-9">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="form__field__address"
                                            placeholder="Straatnaam 1"
                                            v-model="form.address"
                                        >
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="form__field__postal-code" class="col-sm-3 control-label">Postcode</label>
                                    <div class="col-sm-9">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="form__field__postal-code"
                                            placeholder="1111XX"
                                            v-model="form.postal_code"
                                        >
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="form__field__place" class="col-sm-3 control-label">Plaats</label>
                                    <div class="col-sm-9">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="form__field__place"
                                            placeholder="Plaatsnaam"
                                            v-model="form.place"
                                        >
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="form__field__phone" class="col-sm-3 control-label">Telefoon</label>
                                    <div class="col-sm-9">
                                        <input
                                            type="tel"
                                            class="form-control"
                                            id="form__field__phone"
                                            placeholder="0600000000"
                                            v-model="form.phone"
                                        >
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="form__field__file" class="col-sm-3 control-label">Bestand</label>
                                    <div class="col-sm-9">
                                          <input
                                            type="file"
                                            class="form-control"
                                            id="form__field__file"
                                            @change="onFileChange"
                                        >
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="form__field__description" class="col-sm-3 control-label">Beschrijving</label>
                                    <div class="col-sm-9">
                                        <textarea
                                            class="form-control"
                                            id="form__field__description"
                                            rows="3"
                                            v-model="form.description"
                                        ></textarea>
                                    </div>
                                </div>

                                <img class="preview-image" :src="image.src"/>

                            </form>

                        </div>

                        <div class="modal-footer">
                            <div class="col-md-12">
                                <button @click="sendDesign" type="submit" class="btn btn-success pull-right">Verzenden</button>
                                <button @click="closeModal" class="btn btn-warning pull-left">Annuleren</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { API_URL } from './constants';
import { pick } from 'lodash';
import ApiService from './api-service';
import b64toBlob from 'b64-to-blob';

const apiService = new ApiService(API_URL);

export default {
    data() {
        return {
            form: {},
            errorMessages: null,
            showModal: false,
            showAlert: false,
            file: null,
            projectUrl: null
        }
    },
    props: {
        projectId: {
            type: Number,
            required: true
        },
		csrfTokenName: {
			type: String,
			required: true
		},
		csrfHash: {
			type: String,
			required: true
        },
        expense: {
            type: Number,
            required: true
        },
        image: {
            required: true
        },
        selectedPlaysets: {
            default: []
        }
    },
    methods: {
        sendDesign() {

            try {
                if(!this.image) {
                    throw new Error('Image is not ready');
                }

                if(this.expense == 0) {
                    throw new Error('U heeft nog geen speeltoestellen geselecteerd');
                }

                const items = this.selectedPlaysets
                    .map(playset => pick(playset, ['id', 'name', 'price']))
                    .map(playset => Object.assign({}, playset, { total: 1 }));

                this.form = Object.assign({}, this.form, {
                    items: JSON.stringify(items),
                    total_spendings: this.expense,
                    project_id: this.projectId
                });

                this.form[this.csrfTokenName] = this.csrfHash;

                const formData = new FormData();

                formData.append('project_design_image', this.formatImage(), 'blob.png');

                if(this.file) {
                    formData.append('additional_image', this.file);
                }

                Object.keys(this.form)
                    .forEach(key => {
                        formData.append(key, this.form[key]);
                    });

                apiService.addProjectDesign(formData)
                    .then(response => {
                        if(response.error_messages) {
                            this.errorMessages = response.error_messages;
                        }

                        if(response.message) {
                            this.errorMessages = response.message;
                        }

                        if(response.success) {
                            this.resetForm();
                            this.closeModal();
                            this.openAlert();
                        }
                    });
            }
            catch(error) {
                this.errorMessages = error.message;
            }

        },
        resetForm() {
            this.form = {};
            this.file = null;
        },
        formatImage() {
            const [meta, data] = this.image.src.split(';');
            const contentType = meta.split(':')[1];
            const base64 = data.split(',')[1];

            return b64toBlob(base64, contentType);

        },
        onFileChange(event) {
            const files = event.target.files || event.dataTransfer.files;

            if (!files.length) return;

            this.file = files[0];
        },
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.errorMessages = null;
            this.showModal = false;
        },
        openAlert() {
            this.showAlert = true;
            setTimeout(this.closeAlert.bind(this), 5000);
        },
        closeAlert() {
            this.showAlert = false;
        }
    },
    mounted() {
        this.projectUrl = document.cms_site_url + '/projects/project/' + this.projectId;
    }
}
</script>



<style lang="scss" scoped>
textarea {
    resize: vertical;
}

.form {
    &__errors {
        padding: 10px 20px;
        margin-bottom: 20px;
        border-radius: 5px;
    }
}

.modal {
    &__alert {
        &__container {
            position: fixed;
            left: 0;
            right: 0;
            top: 100px;
            z-index: 1040;
        }
    }
}

.preview-image {
    max-width: 100%;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
</style>



// WEBPACK FOOTER //
// assets/vue/apps/participate/submit-modal.vue